import z from "zod";

export const conditionValidator = z.object({
    name: z.string(),
    type: z.string(),
    code: z.string().nullable(),
    // eslint-disable-next-line camelcase
    condition_id: z.number(),
// eslint-disable-next-line camelcase
}).transform(({ name, type, condition_id, code }) => ({
    name,
    type,
    code,
    // eslint-disable-next-line camelcase
    id: condition_id,
}));

export const medicationValidator = z.object({
    medicationId: z.number(),
    name: z.string(),
    soundexList: z.string(),
}).transform(({ name, medicationId, soundexList }) => ({
    name,
    type: "",
    id: medicationId,
}));

export const addressSuggestionValidator = z.object({
    address: z.string(),
    id: z.string(),
}).transform(({ address, id }) => ({
    name: address,
    type: "",
    id,
}));

export type Suggestion = {
    id: number | string,
    name: string,
    type: string,
    code?: string | null,
}
